import React, { useState, useEffect } from 'react';
import { Box, Drawer, Button, AppBar, Toolbar, Typography, IconButton, useMediaQuery, useTheme } from '@mui/material';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import { NavLink } from 'react-router-dom';
import NavBarOptions from './NavBarOptions';
import './NavBar.css';
import { obtenerDatosHotel } from '../../services/motorService';
import Cookies from 'js-cookie';
export default function NavBar({ navList }) {
  const [open, setOpen] = useState(false);
  const [datosHotel, setDatosHotel] = useState({});
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const hotCod = Cookies.get('hotCod');
  useEffect(() => {
    const getData = async () => {
      try {
        const data = await obtenerDatosHotel(hotCod);
        setDatosHotel(data);
      } catch (error) {
        console.error('Error fetching hotel data:', error);
      }
    };
    getData();
  }, []); 

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  return (
    <div>
      <AppBar position='static' sx={{ backgroundColor: '#ffffff', boxShadow: 'none' }}>
        <Toolbar>
          <Typography variant='h6' component='div' sx={{ flexGrow: 1, color: '#000000', display: { xs: 'none', md: 'flex' } }}>
            {datosHotel.MotorHotNombre || 'Hotel Name'} {/* Mostrar el nombre del hotel si está disponible */}
          </Typography>
          <Box sx={{ ml: 'auto', display: { xs: 'none', md: 'flex' } }}>
            {navList.map((item) => (
              <Button
                key={item.title}
                component={NavLink}
                to={item.path}
                sx={({ isActive }) => ({
                  color: isActive ? '#008EAA' : '#808080',
                })}
              >
                {item.title}
              </Button>
            ))}
          </Box>
          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton size='large' edge='start' color='inherit' aria-label='menu' sx={{ mr: 2 }} onClick={toggleDrawer(true)}>
              <MenuRoundedIcon color='primary' />
              <Typography variant='h6' component='div' sx={{ flexGrow: 1, color: '#000000', display: { xs: 'flex', md: 'none' }, ml: 2 }}>
                {datosHotel.MotorHotNombre || 'Hotel Name'} {/* Mostrar el nombre del hotel si está disponible */}
              </Typography>
            </IconButton>
            <Drawer
              open={open}
              onClose={toggleDrawer(false)}
              sx={{ '& .MuiDrawer-paper': { px: isSmallScreen ? 2 : 0 } }} // Padding en mobile
            >
              <NavBarOptions navList={navList} setOpen={setOpen} />
            </Drawer>
          </Box>
        </Toolbar>
      </AppBar>
    </div>
  );
}